// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aging-ranked-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.aging-ranked-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px 6px;
  border-radius: 6px;
}

.aging-ranked-row:hover {
  background: var(--an-surface-hover);
}

.aging-ranked-rank {
  flex: 0 0 20px;
  font-size: 12px;
  font-weight: 700;
  color: var(--an-text-faint);
  text-align: right;
}

.aging-ranked-name {
  flex: 1 1;
  font-size: 13px;
  color: var(--an-text);
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.aging-ranked-count {
  flex: 0 0 72px;
  font-size: 12.5px;
  color: var(--an-text-faint);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.aging-ranked-amount {
  flex: 0 0 88px;
  font-size: 13px;
  font-weight: 700;
  color: var(--an-text);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.aging-ranked-dot {
  flex: 0 0 10px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.aging-ranked-overflow {
  margin-top: 6px;
  font-size: 12px;
  color: var(--an-text-faint);
  font-style: italic;
  padding-left: 6px;
}

.aging-ranked-empty {
  padding: 32px 0;
  text-align: center;
  color: var(--an-text-faint);
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Analytics/charts/AgingRankedList.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".aging-ranked-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.aging-ranked-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 9px 6px;\n  border-radius: 6px;\n}\n\n.aging-ranked-row:hover {\n  background: var(--an-surface-hover);\n}\n\n.aging-ranked-rank {\n  flex: 0 0 20px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--an-text-faint);\n  text-align: right;\n}\n\n.aging-ranked-name {\n  flex: 1;\n  font-size: 13px;\n  color: var(--an-text);\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.aging-ranked-count {\n  flex: 0 0 72px;\n  font-size: 12.5px;\n  color: var(--an-text-faint);\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.aging-ranked-amount {\n  flex: 0 0 88px;\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--an-text);\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.aging-ranked-dot {\n  flex: 0 0 10px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n}\n\n.aging-ranked-overflow {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--an-text-faint);\n  font-style: italic;\n  padding-left: 6px;\n}\n\n.aging-ranked-empty {\n  padding: 32px 0;\n  text-align: center;\n  color: var(--an-text-faint);\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
